import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 22H11V13H2V11H11V2H13V11H22V13H13V22Z" fill={ fill || 'currentColor' } />
    </svg>
);
